import AppBar, { AppBarProps } from './AppBar';

export default AppBar;
export type { AppBarProps };
